<template>
  <div>
    <CRow>
      <CCol col="5">
        <b-form-group :label="$store.state.form.periode" label-for="periodeDenda" class="my-0">
          <Multiselect
            id="periodeDenda"
            v-model="filter.periode"
            :options="listPeriodeGaji"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            :placeholder="$store.state.form.pilihPeriode"
            label="namaPeriode"
            track-by="id"
            @input="hitungTanggal()"
          ></Multiselect>
        </b-form-group>
      </CCol>

      <CCol col="5">
        <b-form-group :label="$store.state.form.bulanTahun" label-for="bulanTahun" class="my-0">
          <date-picker id="bulanTahun" type="month" format="MMMM - YYYY" style="width: 100%" v-model="filter.bulanTahun" @input="hitungTanggal()"></date-picker>
        </b-form-group>
      </CCol>

      <CCol col="2" style="margin-bottom: 6px">
        <div class="w-100 h-100 d-flex align-items-end">
          <b-button variant="danger" class="d-block w-100" v-c-tooltip.hover.click="$store.state.table.tooltipReset" @click="reset()">
            {{ $store.state.form.reset }}
          </b-button>
        </div>
      </CCol>

      <CCol col="12">
        <small class="mx-2"> {{ $moment(filter.tglAwal).format("LL") }} - {{ $moment(filter.tglAkhir).format("LL") }} ({{ filter.jmlHari }} {{ $store.state.form.hari }}) </small>
      </CCol>

      <CCol col="12" class="mt-1 mb-2"><hr /></CCol>
    </CRow>

    <CRow>
      <CCol col="12" md="12" lg="12">
        <CDataTable :items="items" :fields="fields" responsive sorter hover show-empty :loading="tableBusy" />
      </CCol>
    </CRow>
  </div>
</template>

<script>
export default {
  props: ["data", "activeTab"],
  components: {},
  data() {
    return {
      listPeriodeGaji: [],
      items: [],
      filter: {
        periode: null,
        bulanTahun: null,
        tglAwal: null,
        tglAkhir: null,
        jmlHari: "0",
        dataKaryawanId: this.$route.query.dataKaryawanId,
      },
      fields: [
        {
          key: "no",
          label: "No",
          sortDirection: "desc",
          sortable: true,
          class: "table-number text-center",
        },
        {
          key: "namaTanggalAbsen",
          label: "Tanggal",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "tipeKeterlambatan",
          label: "Tipe Keterlambatan",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "kategoriShift",
          label: "Shift",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "absen",
          label: "Check",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
      ],
      tableBusy: false,
    };
  },
  computed: {},
  created() {
    // this.bulan = this.$moment().format('MM')
    // this.tahun = this.$moment().format('YYYY')
    // this.getDatas();
  },
  watch: {
    // 'data.dataKaryawanId'(newVar, oldVar){
    //   if(newVar != oldVar){
    //   this.getDatas();
    //   }
    // },
    async activeTab(newVar) {
      if (newVar == 5) {
        await this.getPeriodeGaji();
        await this.reset();
      }
    },
  },
  async mounted() {},
  methods: {
    async hitungTanggal() {
      const vm = this;
      if (!vm.filter.periode) vm.filter.periode = vm.listPeriodeGaji[0];
      const periode = vm.filter.periode;
      const monthYear = vm.$moment(vm.filter.bulanTahun).format("MM-YYYY");
      //set tanggal terakhir bulan
      const tanggalTerakhirBulan = vm.$moment(`${monthYear}`, "MM-YYYY").endOf("month").format("D");
      periode.xtanggalGajian = periode.tanggalGajian == -1 ? tanggalTerakhirBulan : periode.tanggalGajian;
      periode.xtanggalAwal = periode.tanggalAwal == -1 ? tanggalTerakhirBulan : periode.tanggalAwal;
      periode.xtanggalAkhir = periode.tanggalAkhir == -1 ? tanggalTerakhirBulan : periode.tanggalAkhir;
      //set tanggal default
      vm.filter.tglAwal = vm.$moment(`${periode.xtanggalAwal}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      vm.filter.tglAkhir = vm.$moment(`${periode.xtanggalAkhir}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      //jika tanggal awal adalah bulan sebelumnya (awal - akhir = 30 - 10)
      if (periode.xtanggalAwal > periode.xtanggalAkhir) {
        let tanggal = vm.$moment(`${monthYear}`, "MM-YYYY").subtract(1, "month");
        //jika xtanggalAwal adalah tanggal terakhir bulan
        let awal = periode.xtanggalAwal;
        /*
          jika tanggal awal = -1 (tanggal terakhir bulan) atau
          jika tanggal awal melebihi tanggal dalam bulan (bulan februari tetapi tanggal awal = 30, maka tanggal awal ikut 28 / tanggal akhir dalam bulan)
        */
        if (periode.tanggalAwal == -1 || periode.xtanggalAwal > vm.$moment(tanggal).endOf("month").format("D")) {
          awal = vm.$moment(tanggal).endOf("month").format("D");
        }
        vm.filter.tglAwal = vm.$moment(`${awal}-${tanggal.format("MM")}-${tanggal.format("YYYY")}`, "D-MM-YYYY").format("YYYY-MM-DD");
      } else {
        //jika tanggal awal melebihi tanggal dalam bulan (bulan februari tetapi tanggal awal = 30, maka tanggal awal ikut 28 / tanggal awal dalam bulan)
        if (periode.xtanggalAwal > tanggalTerakhirBulan) {
          vm.filter.tglAwal = vm.$moment(`${tanggalTerakhirBulan}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
        }
      }
      //jika tanggal akhir melebihi tanggal dalam bulan (bulan februari tetapi tanggal akhir = 30, maka tanggal akhir ikut 28 / tanggal akhir dalam bulan)
      if (periode.xtanggalAkhir > tanggalTerakhirBulan) {
        vm.filter.tglAkhir = vm.$moment(`${tanggalTerakhirBulan}-${monthYear}`, "D-MM-YYYY").format("YYYY-MM-DD");
      }
      vm.filter.jmlHari = vm.$moment(vm.filter.tglAkhir).diff(vm.$moment(vm.filter.tglAwal), "Days") + 1;
      vm.getDatas();
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async getDatas() {
      let vm = this;
      let tun = await vm.$axios.post("absensiKaryawanMobile/listRekapTerlambat", vm.filter);
      // console.log('tun', tun);
      vm.items =
        tun.data.status == 200
          ? tun.data.data.map((x, idx) => {
              return {
                ...x,
                no: idx + 1,
                namaTanggalAbsen: vm.$moment(x.tanggalAbsen).format("LLLL"),
                tipeKeterlambatan: x.tipeKeterlambatan ? x.tipeKeterlambatan : " - ",
                kategoriShift: x.kategoriShift ? x.kategoriShift : " - ",
                absen: x.absen ? x.absen : " - ",
              };
            })
          : [];
    },
    async getPeriodeGaji() {
      let vm = this;
      let listPeriodeGaji = await vm.$axios.post("periodeGajiMitra/list");
      console.log("listPeriodeGaji : ", listPeriodeGaji);
      vm.listPeriodeGaji =
        listPeriodeGaji.data.status == 200
          ? listPeriodeGaji.data.data.map((x) => {
              x.namaTanggalGajian = x.tanggalGajian == -1 ? "akhir bulan" : "Tanggal " + x.tanggalGajian;
              x.namaTanggalAwal = x.tanggalAwal == -1 ? "akhir bulan" : x.tanggalAwal;
              x.namaTanggalAkhir = x.tanggalAkhir == -1 ? "akhir bulan" : x.tanggalAkhir;
              return {
                ...x,
                namaPeriode: `Gajian ${x.namaTanggalGajian} (Kerja ${x.namaTanggalAwal} - ${x.namaTanggalAkhir})${x.isBpjs ? ", BPJS" : ""}`,
              };
            })
          : [];
    },
    reset() {
      const vm = this;
      const month = vm.$moment().format("MM");
      const year = vm.$moment().format("YYYY");
      vm.filter.bulanTahun = new Date(vm.$moment(`01-${month}-${year}`, "DD-MM-YYYY"));
      vm.filter.periode = vm.listPeriodeGaji[0];
      this.hitungTanggal();
    },
    triggerAlert(event) {
      let vm = this;
      vm.$store.commit("set_alert", event);
    },
  },
};
</script>
